import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import React, { Component } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import MenuItem from "@material-ui/core/MenuItem";
import { withTranslation, Trans } from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import InputLabel from "@material-ui/core/InputLabel";
import { withStyles } from "@material-ui/core/styles";
import ColourPickerSingleDialog from "../dialog/ColourPickerSingleDialog";
const styles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
});
export class TemplateSetup extends Component {
  componentDidMount() {
    if (this.props.settings) {
      this.setState({
        settings: {
          ...this.props.settings,
          border: {
            colour: "#ffea00",
            style: "dotted",
            margin: "2px",
            width: "2px",
          },
        },
      });
    }
  }
  state = {
    border: false,
    settings: { type: "card" },
    changeColoursDialogOpen: false,
  };
  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <DialogTitle />
        <DialogContent>
          <FormLabel>
            <Trans i18nKey="template_setup_sections_type" />
            <RadioGroup
              onChange={this.typeChanged}
              id="position"
              value={this.state.settings.type}
            >
              <FormControlLabel
                value="cards"
                control={<Radio />}
                label={t("template_setup_page_cards")}
              />
              <FormControlLabel
                value="tabs"
                control={<Radio />}
                label={t("template_setup_page_tabs")}
              />
              <FormControlLabel
                value="borders"
                control={<Radio />}
                label={t("template_setup_page_borders")}
              />
              <FormControlLabel
                value="none"
                control={<Radio />}
                label={t("template_setup_border_none")}
              />
            </RadioGroup>
          </FormLabel>
          {this.state.settings.type === "borders" ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                display: "flex",
                flex: 1,
              }}
            >
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-label-placeholder">
                  <Trans i18nKey="template_setup_border_style" />
                </InputLabel>
                <Select
                  value={this.state.settings.border.style}
                  onChange={this.changeBorderStyle}
                  input={
                    <Input name="classification" id="age-label-placeholder" />
                  }
                  name="age"
                >
                  <MenuItem value={"none"}>
                    <Trans i18nKey="template_setup_border_none" />
                  </MenuItem>
                  <MenuItem value={"dotted"}>
                    <Trans i18nKey="template_setup_border_dotted" />
                  </MenuItem>
                  <MenuItem value={"solid"}>
                    <Trans i18nKey="template_setup_border_solid" />
                  </MenuItem>
                  <MenuItem value={"dashed"}>
                    <Trans i18nKey="template_setup_border_dashed" />
                  </MenuItem>
                  <MenuItem value={"double"}>
                    <Trans i18nKey="template_setup_border_double" />
                  </MenuItem>
                  <MenuItem value={"groove"}>
                    <Trans i18nKey="template_setup_border_groove" />
                  </MenuItem>
                  <MenuItem value={"ridge"}>
                    <Trans i18nKey="template_setup_border_ridge" />
                  </MenuItem>
                  <MenuItem value={"inset"}>
                    <Trans i18nKey="template_setup_border_inset" />
                  </MenuItem>
                  <MenuItem value={"outset"}>
                    <Trans i18nKey="template_setup_border_outset" />
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <Select
                  open={false}
                  value={this.state.settings.border.colour}
                  onChange={this.changeBorderStyle}
                  onClick={this.openColourPicker}
                  input={
                    <Input name="classification" id="age-label-placeholder" />
                  }
                  name="age"
                >
                  <MenuItem value={this.state.settings.border.colour}>
                    {this.state.settings.border.colour}
                  </MenuItem>
                </Select>
                <ColourPickerSingleDialog
                  open={this.state.changeColoursDialogOpen}
                  onClose={this.handleChangeColoursDialogClosed}
                  onSubmit={this.changeBorderColour}
                />
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-label-placeholder">
                  <Trans i18nKey="template_setup_width" />
                </InputLabel>
                <Select
                  value={this.state.settings.border.width}
                  onChange={this.changeBorderWidth}
                  input={
                    <Input name="classification" id="age-label-placeholder" />
                  }
                  name="age"
                >
                  <MenuItem value={"1px"}>
                    <Trans i18nKey="template_setup_border_width_very_thin" />
                  </MenuItem>
                  <MenuItem value={"2px"}>
                    <Trans i18nKey="template_setup_border_width_thin" />
                  </MenuItem>
                  <MenuItem value={"4px"}>
                    <Trans i18nKey="template_setup_border_width_medium" />
                  </MenuItem>
                  <MenuItem value={"8px"}>
                    <Trans i18nKey="template_setup_border_width_thick" />
                  </MenuItem>
                  <MenuItem value={"16px"}>
                    <Trans i18nKey="template_setup_border_width_very_thick" />
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-label-placeholder">
                  <Trans i18nKey="template_setup_margin" />
                </InputLabel>
                <Select
                  value={this.state.settings.border.margin}
                  onChange={this.changeBorderMargin}
                  input={
                    <Input name="classification" id="age-label-placeholder" />
                  }
                  name="age"
                >
                  <MenuItem value={"2px"}>
                    <Trans i18nKey="template_setup_border_width_thin" />
                  </MenuItem>
                  <MenuItem value={"4px"}>
                    <Trans i18nKey="template_setup_border_width_medium" />
                  </MenuItem>
                  <MenuItem value={"8px"}>
                    <Trans i18nKey="template_setup_border_width_thick" />
                  </MenuItem>
                  <MenuItem value={"16px"}>
                    <Trans i18nKey="template_setup_border_width_very_thick" />
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.close}>
            <Trans i18nKey="global_cancel" />
          </Button>
          <Button
            id="acceptButton"
            onClick={this.props.setSettings.bind(this, this.state.settings)}
          >
            <Trans i18nKey="global_save" />
          </Button>
        </DialogActions>
      </div>
    );
  }
  openColourPicker = () => {
    this.setState({
      changeColoursDialogOpen: !this.state.changeColoursDialogOpen,
    });
  };
  changeBorderColour = (value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, colour: value },
      },
      changeColoursDialogOpen: false,
    });
  };
  typeChanged = (event, value) => {
    this.setState({ settings: { ...this.state.settings, type: value } });
  };
  changeBorderStyle = (event, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, style: event.target.value },
      },
    });
  };
  changeBorderWidth = (event, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, width: event.target.value },
      },
    });
  };
  changeBorderMargin = (event, value) => {
    this.setState({
      settings: {
        ...this.state.settings,
        border: { ...this.state.settings.border, margin: event.target.value },
      },
    });
  };
}
export default withStyles(styles)(withTranslation()(TemplateSetup));
